<template>
  <div>
    <page-header>
      <div slot="content">
        <header-title title="Page Not Found"></header-title>
      </div>
    </page-header>
    <div id="copy" class="body">
      <h1>Oops! We couldn't find the page you are looking for.</h1>
      <h2>We're doing a remodel, so the page may be here the next time you visit.</h2>
    </div>
  </div>
</template>

<script>
import HeaderTitle from '@/components/HeaderTitle'
import PageHeader from '@/components/PageHeader'
export default {
  name: 'page-not-found',
  data () {
    return {
      title: 'Page Not Found'
    }
  },
  components: {
    HeaderTitle,
    PageHeader
  }
}
</script>



// WEBPACK FOOTER //
// PageNotFound.vue?4a3d56d2